{
  "page": {
    "title": "Lookup lists",
    "subtitle": "Inactive items disappear from new selections but stay visible on past records"
  },
  "dialog": {
    "editTitle": "Edit {{name}}",
    "addTitle": "Add item"
  },
  "table": {
    "itemsCount": "{{n}} items",
    "addTo": "Add to {{name}}",
    "emptyTitle": "The list is empty",
    "emptyHint": "Add the first item.",
    "activated": "{{name}} activated",
    "deactivated": "{{name}} deactivated",
    "activate": "Activate {{name}}",
    "deactivate": "Deactivate {{name}}",
    "edit": "Edit {{name}}"
  },
  "columns": {
    "name": "Name",
    "english": "English",
    "code": "Code",
    "order": "Order",
    "active": "Active"
  },
  "form": {
    "nameAr": "Arabic name",
    "nameEn": "English name",
    "nameEnHint": "Optional — used to generate a fixed code for the item",
    "order": "Order",
    "orderHint": "Lower numbers appear first",
    "saving": "Saving…",
    "saveChanges": "Save changes",
    "add": "Add",
    "saved": "Changes saved",
    "added": "Added",
    "codeExists": "An item with the same English name already exists in this list",
    "saveFailed": "Couldn't save"
  },
  "validation": {
    "nameArRequired": "Arabic name is required",
    "max60": "Maximum 60 characters",
    "sortOrder": "A number from 0 to 999"
  }
}
